<template>
  <div class="work-search">
    <div class="work-search-title">
      <van-icon name="arrow-left" size="24px" @click="back" />
      <van-search
        ref="search"
        class="work-search-title-search"
        :placeholder="languages.inputWorkSearch"
        background="transparent"
        clearable
        shape="round"
        clear-trigger="always"
        v-model="originSearchValue"
        @clear="() => onInput({ target: { value: '' } })"
        @focus="clearResult"
      >
        <template #left-icon>
          <div></div>
        </template>
        <template #right-icon>
          <van-button
            class="work-search-title-btn"
            round
            block
            type="info"
            @click="onRefreshList"
          >
            {{ languages.smartOrderSearch }}
          </van-button>
        </template>
      </van-search>
    </div>
    <div class="work-search-result" v-if="workList">
      <FaqItem
        v-for="(item, index) in workList"
        :key="item.SUPPORT_ORDER_ID"
        :faqItem="item"
        :index="index"
        :visibleControl="item.visibleControl"
        :transitionDelay="item.transitionDelay"
      ></FaqItem>
    </div>
    <p
      v-if="finishedList && workList.length === 0"
      class="work-search-result-tip"
    >
      {{ languages.smartOrderNoResult }}
    </p>
    <div class="work-search-wrap" v-if="!isJumpAiBot">
      <section-title
        :title="languages.smartOrderCreate"
        v-show="hasWorkTempList && !searchValue"
      ></section-title>
      <work-temp-list
        v-show="hasWorkTempList && !searchValue"
        :source="locationType.searchPage"
      ></work-temp-list>
    </div>

    <!-- <ContactServerBtn :source="locationType.searchPage"></ContactServerBtn> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import FaqItem from '@components/officialSupport/FaqItem.vue';
import SectionTitle from '@components/officialSupport/common/SectionTitle.vue';
import WorkTempList from '@components/officialSupport/WorkTempList.vue';
import ContactServerBtn from '@components/officialSupport/ContactServerBtn.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { locationType } from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import aiBot from '@mixins/officialSupport/aiBot';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'WorkSearch',
  mixins: [iframeMessage, pointStayTime, aiBot],
  data() {
    return {
      originSearchValue: undefined,
      searchValue: undefined, // 搜索关键字
      loadingList: false, // 加载中
      finishedList: false, // 列表数据全部加载完
      workList: [], //搜索列表数据
      errorLoad: false,
      timer: null,
      locationType
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      workTempList: state => state.workTempList
    }),
    hasWorkTempList() {
      return this.workTempList?.length > 0;
    }
  },
  created() {
    this.postMessageToParent('visibleLangChoose', false);
  },
  methods: {
    ...mapActions(['getWorkList', 'searchFaq']),
    clearResult() {
      this.workList = [];
      this.finishedList = false;
    },
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    // 监听原生搜索框input时间
    listenerSearchInput() {
      const searchInputEle = this.$refs?.search?.querySelector(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.addEventListener('input', this.onInput);
      }
    },
    // 取消监听原生搜索框input时间
    unListenerSearchInput() {
      const searchInputEle = this.$refs?.search?.querySelector(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.removeEventListener('input', this.onInput);
      }
    },
    onInput(e) {
      const value = e?.target?.value;
      this.searchValue = value;
      this.clearResult();
      clearTimeout(this.timer);
      if (value === void 0 || value === '') {
        this.workList = [];
        this.finishedList = false;
        return;
      }
      this.timer = setTimeout(
        async () => {
          try {
            window.scrollTo(0, 0);
          } catch (e) {
            console.error(e);
          }
          await this.onRefreshList();
        },
        value === void 0 || value === '' ? 0 : 600
      );
    },
    // 重新加载工单列表
    async onRefreshList() {
      this.workList = [];
      // 表示可以重新加载数据
      this.finishedList = false;
      // 重新加载数据,将 loadingList 设置为 true，表示处于加载状态
      this.loadingList = true;
      // 开始加载
      await this.onLoadList();
      return Promise.resolve();
    },
    // 加载工单列表
    async onLoadList() {
      try {
        if (this.searchValue) {
          window.csorderDataLayer.push({
            eventName: 'faqSearch',
            eventValue: {
              text: this.searchValue || ''
            }
          });
        }
        const submitKeyword =
          this.searchValue && this.searchValue.trim() !== ''
            ? this.searchValue
            : '';
        const data = await this.searchFaq({
          content: submitKeyword,
          searchType: 1
        });
        const newData = data?.articleList?.length ? data.articleList : [];
        const decorateNewData = [];
        for (let i = 0, len = newData.length; i < len; i++) {
          const item = newData[i];
          item.visibleControl = false; // 控制置顶和删除操作是否显示
          item.transitionDelay = i * 0.2; // 动画延迟加载 0.2s * 索引值
          decorateNewData.push(item);
        }
        this.workList.push(...newData);
        this.finishedList = true;
        // 表示本次加载完成，这个计算是等插入动画完成后才是加载完成
        await new Promise(resolve => {
          setTimeout(() => {
            this.loadingList = false;
            resolve();
          }, newData.length * 100);
        });
      } catch (e) {
        console.log(e);
        this.loadingList = false;
        this.errorLoad = true;
      }
      return Promise.resolve();
    }
  },
  mounted() {
    this.listenerSearchInput();
  },
  beforeMount() {
    this.unListenerSearchInput();
  },
  components: {
    PageLayout,
    FaqItem,
    SectionTitle,
    WorkTempList,
    ContactServerBtn
  }
};
</script>

<style lang="scss" scoped>
.work-search {
  &-wrap {
    padding: 0 10px;
    box-sizing: border-box;
  }
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--menu-item-top-bgColor);
    height: 91px;
    box-sizing: border-box;
    padding: 10px;
    margin-bottom: 25px;
    &-search {
      padding: 0;
      height: 60px;
      width: 93%;
      ::v-deep .van-search__content {
        height: 60px;
      }
      ::v-deep .van-cell {
        line-height: 50px;
      }
    }
    &-btn {
      height: 32px;
      border-radius: 26px;
      line-height: 32px;
      font-size: 16px;
    }
  }
  &-result {
    width: 100%;
    padding: 10px;
    margin: auto;
    box-sizing: border-box;
    &-tip {
      text-align: center;
      font-size: 16px;
      color: var(--text-color);
    }
  }
}
</style>
